import { Form } from "antd";
import TextInput from "components/Inputs/TextInput/TextInput";
import centralApi from "services/centralApi";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "redux/features/app/authTokenSlice";
import useMessage from "hooks/useMessage";
import { t } from "i18next";
import { API_ENDPOINTS } from "utils/constants";
import PrimaryButton from "components/Buttons/PrimaryButton/PrimaryButton";
import { getFeaturesSettings } from "redux/features/app/featuresSettingSlice";

const NotificationEmail = () => {
  const loginUser = useSelector((state: any) => state.loginUser.data);
  const { appId } = useSelector((state: any) => state.activeApp);
  const activity_email =
    useSelector(
      (state: any) =>
        state.featuresSetting?.data[0]?.activity_email || []
    );

  const dispatch: any = useDispatch();
  const { showError, showSuccess } = useMessage();

  const handleSubmit = async (values: any) => {
    try {
      const authToken = await dispatch(getToken()).unwrap();
  
      const emailArray = values.activity_email
        .split(",")
        .map((email: string) => email.trim())
        .filter((email: string) => email);
  
      const payload = {
        args: {
          activity_email: emailArray,
        },
        app_id: appId,
        api_key: loginUser.api_key,
        authToken,
      };
  
      await centralApi("POST", API_ENDPOINTS.SAVE_APP_SETTING_URL, payload);
  
      dispatch(
        getFeaturesSettings({
          app_id: appId,
          api_key: loginUser.api_key,
        })
      );
  
      showSuccess(t("sucessfullySavedLabel"));
    } catch (error) {
      showError(t("somethingWrongLabel"));
    }
  };
  
  

  return (
    <div className="bg-white ">
      <Form
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={{
          activity_email,
        }}
      >
        <Form.Item
          label="Notification Emails"
          name="activity_email"
          rules={[
            {
              required: true,
              message: "Please enter at least one email",
            },
          ]}
        >
          <TextInput
            placeholder="Enter emails separated by comma"
            onBlur={(e: any) => {
              const value = e.target.value;
              const emails = value
                .split(",")
                .map((email: string) => email.trim())
                .filter((email: string) => email);
              e.target.value = emails.join(", ");
            }}
          />
        </Form.Item>

        <Form.Item>
          <PrimaryButton type="primary" htmlType="submit">
            {t("saveLabel")}
          </PrimaryButton>
        </Form.Item>
      </Form>
    </div>
  );
};

export default NotificationEmail;
